'use strict';

angular.module('shiftTraderApp')
  .directive('saEmployeeHoursBar', ['$compile', '$timeout', '$parse', function ($compile, $timeout, $parse) {
      var generateMarkerTemplate = function(type) {
        var classes = ['marker'];
        if (type === 'overtimeThreshold') {
          classes.push('overtimeThreshold');
        } else if (type === 'targetHours') {
          classes.push('targetHours bottom');
        } else if (type === 'targetHours2') {
          classes.push('targetHours2 bottom');
        }

        return '<div class="' + classes.join(' ') + '"></div>';
      };

      var generateLabelTemplate = function(type, data) {
        var classes = ['sa_employee_hours_bar_label'];
        var text, tooltipText;
        if (type === 'overtimeThreshold') {
          classes.push('overtimeThreshold');
          text = data.overtimeThreshold;
          tooltipText = 'Overtime Threshold';
        } else if (type === 'targetHours') {
          classes.push('targetHours');
          text = data.targetHours;
          tooltipText = 'Target Hours effective ' + data.effectiveDateFormatted;
        } else if (type === 'targetHours2') {
          classes.push('targetHours2');
          text = data.targetHours;
          tooltipText = 'Target Hours effective ' + data.effectiveDateFormatted;
        } else if (type === 'lastWeekLaborHours') {
          classes.push('lastWeekLaborHours');
          text = data.lastWeekLaborHours;
          tooltipText = data.lastWeekLaborHours + 'hrs last week';
        }

        return '<div class="' + classes.join(' ') + '" uib-tooltip="' + tooltipText + '" tooltip-placement="bottom">' + text + '</div>';
      };

      var generateLastWeekHoursFillTemplate = function(laborHours) {
        return '<div class="last_week_hours_fill" uib-tooltip="' + laborHours + 'hrs Last Week" tooltip-placement="bottom"></div>';
      };

      var generateLaborHoursFillTemplate = function(laborHours) {
        return '<div class="hours_fill" uib-tooltip="' + laborHours + 'hrs Current Week" tooltip-placement="bottom"></div>';
      };

      var baseTemplate = '<div class="sa_employee_hours_bar">' +
        '<div class="labels top"></div>' +
        '<div class="bar">' +
          '<div class="markers"></div>' +
        '</div>' +
        '<div class="labels bottom"></div>' +
        '</div>';

      return {
        restrict: 'EA',
        template: baseTemplate,
        scope: {
          user: '=',
          //targetHours: '@',
          //laborHours: '@',
          //overtimeThreshold: '@'
          lastWeekLaborHours: '='
        },
        link: function postLink(scope, element, attrs) {
          var renderComplete = false;
          var renderLastWeekAfterRender = false;

          // max hrs value means right most edge of bar is VALUE
          var MAXHOURS = 60;
          var barWidthInPx;

          var renderLastWeekOnly = function() {
            //console.log(window.performance.now(), 'renderLastWeekOnly ', scope.user.name);
            if (!renderComplete) {
              renderLastWeekAfterRender = true;
            }

            var lastWeekHoursFill = element.find('.last_week_hours_fill');

            if (scope.lastWeekLaborHours) {
              if (lastWeekHoursFill) {
                lastWeekHoursFill.remove();
              }

              lastWeekHoursFill = $compile(generateLastWeekHoursFillTemplate(scope.lastWeekLaborHours))(scope);
              element.find('.bar').prepend(lastWeekHoursFill);

              lastWeekHoursFill.css({
                width: (parseInt(scope.lastWeekLaborHours || 0)) / MAXHOURS * 100.0 + '%'
              });
            }
            renderLastWeekAfterRender = false;
          };

          var getAttrValue = function(valName) {
            return $parse(attrs[valName])(scope.$parent);
          };

          var render = function() {
            //console.log(window.performance.now(), 'render start', scope.user.name);
            var animations = [];
            var leftRatio, labelDimensions;

            // pull overtimeThreshold off of the $parent scope so as to not set up another watch
            var ot = parseInt(getAttrValue('overtimeThreshold'));
            var laborHours = parseInt(getAttrValue('laborHours') || '0') || 0;
            var targetHours = getAttrValue('targetHours');

            var hoursFill = element.find('.hours_fill');

            var markersContainer = element.find('.markers');
            markersContainer.empty();

            var labelsTopContainer = element.find('.labels.top');
            labelsTopContainer.empty();

            var labelsBottomContainer = element.find('.labels.bottom');
            labelsBottomContainer.empty();

            // figure out what the width of the whole bar is
            barWidthInPx = element.width();

            if (hoursFill) {
              hoursFill.remove();
            }

            hoursFill = $compile(generateLaborHoursFillTemplate(laborHours))(scope);
            element.find('.bar').prepend(hoursFill);

            animations.push({
              e: hoursFill,
              fn: function(e) {
                e.css({
                  width: (laborHours || 0) / MAXHOURS * 100.0 + '%'
                });
              }
            });

            if (ot <= MAXHOURS) {
              // add an overtimeThreshold marker
              var overtimeThresholdMarker = $(generateMarkerTemplate('overtimeThreshold'));

              var overtimeThresholdLabel = $compile(generateLabelTemplate('overtimeThreshold', {
                overtimeThreshold: ot
              }))(scope);

              leftRatio = ot / MAXHOURS;
              animations.push({
                e: overtimeThresholdMarker,
                leftRatio: leftRatio,
                fn: function(e, ratio) {
                  e.css({
                    opacity: 1,
                    left: ratio * 100 + '%'
                  });
                }
              });

              markersContainer.append(overtimeThresholdMarker);

              //labelDimensions = getHiddenDimensions(overtimeThresholdLabel);
              labelDimensions = { width: 12 };

              labelsTopContainer.append(overtimeThresholdLabel);
              animations.push({
                e: overtimeThresholdLabel,
                leftRatio: leftRatio,
                fn: function (e, ratio) {
                  e.css({
                    opacity: 1,
                    left: barWidthInPx * ratio + 2 - labelDimensions.width / 2.0
                  });
                }
              });
            }

            if (targetHours && targetHours.length > 0) {
              _.each(targetHours, function(target, idx) {
                var type = idx === 0 ? 'targetHours' : 'targetHours2';
                var targetMarker = $(generateMarkerTemplate(type));
                leftRatio = target.target_hours / MAXHOURS;

                var targetHoursLabel = $compile(generateLabelTemplate(type, {
                  targetHours: target.target_hours,
                  effectiveDateFormatted: target.effective_date.format('MMM D, YYYY h:mma').slice(0, -1)
                }))(scope);

                //labelDimensions = getHiddenDimensions(targetHoursLabel);
                labelDimensions = { width: 12 };

                animations.push({
                  e: targetHoursLabel,
                  leftRatio: leftRatio,
                  fn: function(e, ratio) {
                    e.css({
                      opacity: 1,
                      left: barWidthInPx * ratio + 2 - labelDimensions.width / 2.0
                    });
                  }
                });

                labelsBottomContainer.append(targetHoursLabel);

                animations.push({
                  e: targetMarker,
                  leftRatio: leftRatio,
                  fn: function(e, ratio) {
                    e.css({
                      left: ratio * 100 + '%',
                      opacity: 1
                    });
                  }
                });
                markersContainer.append(targetMarker);
              });
            }

              _.each(animations, function(anim) {
                anim.fn(anim.e, anim.leftRatio);
              });


            renderComplete = true;
            if (renderLastWeekAfterRender || !_.isUndefined(scope.lastWeekLaborHours)) {
              renderLastWeekOnly();
            }
            //console.log(window.performance.now(), 'render end ', scope.user.name);
          };

          $timeout(function() {
            //console.log('calling render: ', scope.user.name);
            render();
          }, 250);

          //render();

          var lastWeekDereg = scope.$watch('lastWeekLaborHours', function(newVal, oldVal) {
            if (newVal !== oldVal) {
              //console.log(window.performance.now(), 'triggered $watch lastWeekLaborHours ', scope.user.name, newVal, oldVal);
              renderLastWeekOnly();
              lastWeekDereg();
            }
          });

        }
      };
  }]);
